// Learning Cycle System and AI Feedback Data
// This file contains data for the learning cycle system, AI feedback, and assessment features

export const learningCycleStages = [
  {
    id: 'initial_check',
    title: {
      traditional: '當初檢查',
      simplified: '当初检查',
      english: 'Initial Check'
    },
    description: {
      traditional: '學習者回答提問旁讓ELSA了解你的學習需求, 並個人化你的學習路徑',
      simplified: '学习者回答提问旁让ELSA了解你的学习需求, 并个性化你的学习路径',
      english: 'Learners answer questions to let ELSA understand your learning needs and personalize your learning path'
    },
    icon: '🔍',
    iconColor: 'from-blue-400 to-cyan-500',
    position: 'top-center'
  },
  {
    id: 'feedback',
    title: {
      traditional: '回饋',
      simplified: '反馈',
      english: 'Feedback'
    },
    description: {
      traditional: '學習者將收到有關發音和回饋,有助提高技能並快速進步',
      simplified: '学习者将收到有关发音和反馈,有助提高技能并快速进步',
      english: 'Learners will receive feedback on pronunciation and feedback, helping to improve skills and progress quickly'
    },
    icon: '📈',
    iconColor: 'from-orange-400 to-red-500',
    position: 'bottom-left'
  },
  {
    id: 'roleplay_interaction',
    title: {
      traditional: '角色扮演互動',
      simplified: '角色扮演互动',
      english: 'Roleplay Interaction'
    },
    description: {
      traditional: '學習者將透過情境模擬與ELSA進行互動，練習真實對話並獲得即時回饋',
      simplified: '学习者将通过情境模拟与ELSA进行互动，练习真实对话并获得即时反馈',
      english: 'Learners will interact with ELSA through scenario simulations, practice real conversations, and receive instant feedback'
    },
    icon: '💬',
    iconColor: 'from-green-400 to-emerald-500',
    position: 'bottom-center'
  },
  {
    id: 'real_situations',
    title: {
      traditional: '透過真實的狀況',
      simplified: '通过真实的状况',
      english: 'Through Real Situations'
    },
    description: {
      traditional: '課程據實際上的溝通情境 技巧而設計',
      simplified: '课程据实际上的沟通情境 技巧而设计',
      english: 'Courses are designed based on actual communication scenarios and skills'
    },
    icon: '📚',
    iconColor: 'from-purple-400 to-indigo-500',
    position: 'bottom-right'
  }
];

export const learningPackages = {
  free: {
    name: {
      traditional: '免費',
      simplified: '免费',
      english: 'Free'
    },
    features: [
      {
        name: {
          traditional: '補習課程 (IELTS, HarperCollins)',
          simplified: '补习课程 (IELTS, HarperCollins)',
          english: 'Tutoring courses (IELTS, HarperCollins)'
        },
        available: false,
        status: {
          traditional: '限制',
          simplified: '限制',
          english: 'Limited'
        }
      },
      {
        name: {
          traditional: '商務英語課程 (Oxfords)',
          simplified: '商务英语课程 (Oxfords)',
          english: 'Business English courses (Oxfords)'
        },
        available: false,
        status: {
          traditional: '限制',
          simplified: '限制',
          english: 'Limited'
        }
      },
      {
        name: {
          traditional: '建立學習路徑',
          simplified: '建立学习路径',
          english: 'Create learning path'
        },
        available: false,
        status: {
          traditional: '限制',
          simplified: '限制',
          english: 'Limited'
        }
      },
      {
        name: {
          traditional: '實際上的狀況角色扮演',
          simplified: '实际上的状况角色扮演',
          english: 'Real-life situation role-playing'
        },
        available: false,
        status: {
          traditional: '限制',
          simplified: '限制',
          english: 'Limited'
        }
      },
      {
        name: {
          traditional: 'AI 教練',
          simplified: 'AI 教练',
          english: 'AI Coach'
        },
        available: false,
        status: {
          traditional: '限制',
          simplified: '限制',
          english: 'Limited'
        }
      },
      {
        name: {
          traditional: '無廣告',
          simplified: '无广告',
          english: 'No ads'
        },
        available: false,
        status: {
          traditional: '✗',
          simplified: '✗',
          english: '✗'
        }
      }
    ]
  },
  premium: {
    name: {
      traditional: 'Premium方案',
      simplified: 'Premium方案',
      english: 'Premium Plan'
    },
    features: [
      {
        name: {
          traditional: '補習課程 (IELTS, HarperCollins)',
          simplified: '补习课程 (IELTS, HarperCollins)',
          english: 'Tutoring courses (IELTS, HarperCollins)'
        },
        available: true,
        status: {
          traditional: '✓',
          simplified: '✓',
          english: '✓'
        }
      },
      {
        name: {
          traditional: '商務英語課程 (Oxfords)',
          simplified: '商务英语课程 (Oxfords)',
          english: 'Business English courses (Oxfords)'
        },
        available: true,
        status: {
          traditional: '✓',
          simplified: '✓',
          english: '✓'
        }
      },
      {
        name: {
          traditional: '建立學習路徑',
          simplified: '建立学习路径',
          english: 'Create learning path'
        },
        available: true,
        status: {
          traditional: '✓',
          simplified: '✓',
          english: '✓'
        }
      },
      {
        name: {
          traditional: '實際上的狀況角色扮演',
          simplified: '实际上的状况角色扮演',
          english: 'Real-life situation role-playing'
        },
        available: true,
        status: {
          traditional: '✓',
          simplified: '✓',
          english: '✓'
        }
      },
      {
        name: {
          traditional: 'AI 教練',
          simplified: 'AI 教练',
          english: 'AI Coach'
        },
        available: true,
        status: {
          traditional: '✓',
          simplified: '✓',
          english: '✓'
        }
      },
      {
        name: {
          traditional: '無廣告',
          simplified: '无广告',
          english: 'No ads'
        },
        available: true,
        status: {
          traditional: '✓',
          simplified: '✓',
          english: '✓'
        }
      }
    ]
  }
};

export const aiFeedbackData = {
  title: {
    traditional: 'Real-time & Personalized AI Feedback',
    simplified: 'Real-time & Personalized AI Feedback',
    english: 'Real-time & Personalized AI Feedback'
  },
  subtitle: {
    traditional: 'Real-time & Personalized AI Feedback to Track Your Growth',
    simplified: 'Real-time & Personalized AI Feedback to Track Your Growth',
    english: 'Real-time & Personalized AI Feedback to Track Your Growth'
  },
  description: {
    traditional: 'Get instant, tailored feedback on your fluency, intonation, pronunciation, grammar, and vocabulary, and track your improvement with detailed performance data.',
    simplified: 'Get instant, tailored feedback on your fluency, intonation, pronunciation, grammar, and vocabulary, and track your improvement with detailed performance data.',
    english: 'Get instant, tailored feedback on your fluency, intonation, pronunciation, grammar, and vocabulary, and track your improvement with detailed performance data.'
  },
  processingMessage: {
    traditional: 'Well done! We are computing your feedback.',
    simplified: 'Well done! We are computing your feedback.',
    english: 'Well done! We are computing your feedback.'
  },
  assessmentSummary: {
    title: {
      traditional: 'Assessment Summary',
      simplified: 'Assessment Summary',
      english: 'Assessment Summary'
    },
    overallFeedback: {
      traditional: 'Overall, well done and keep up the friendly and respectful tone.',
      simplified: 'Overall, well done and keep up the friendly and respectful tone.',
      english: 'Overall, well done and keep up the friendly and respectful tone.'
    },
    pronunciation: {
      traditional: 'Pronunciation: Advanced',
      simplified: 'Pronunciation: Advanced',
      english: 'Pronunciation: Advanced'
    },
    vocabulary: {
      traditional: 'Vocabulary: Intermediate',
      simplified: 'Vocabulary: Intermediate',
      english: 'Vocabulary: Intermediate'
    }
  },
  aiCoachSection: {
    title: {
      traditional: 'An AI Coach that Helps You Stay Focused & Motivated',
      simplified: 'An AI Coach that Helps You Stay Focused & Motivated',
      english: 'An AI Coach that Helps You Stay Focused & Motivated'
    },
    description: {
      traditional: 'Strict but caring, the ELSA AI Coach pays close attention to every bit of progress you make along the way, and reminds you when you go off track. You will be rewarded for your hard work.',
      simplified: 'Strict but caring, the ELSA AI Coach pays close attention to every bit of progress you make along the way, and reminds you when you go off track. You will be rewarded for your hard work.',
      english: 'Strict but caring, the ELSA AI Coach pays close attention to every bit of progress you make along the way, and reminds you when you go off track. You will be rewarded for your hard work.'
    }
  },
  speechRecognitionSection: {
    title: {
      traditional: 'Real-Time Speech Recognition Feedback',
      simplified: 'Real-Time Speech Recognition Feedback',
      english: 'Real-Time Speech Recognition Feedback'
    },
    description: {
      traditional: 'We are the first and best speech recognition app designed to evaluate and give immediate detailed feedback on pronunciation and fluency. This enables you to quickly identify and learn the correct pronunciation.',
      simplified: 'We are the first and best speech recognition app designed to evaluate and give immediate detailed feedback on pronunciation and fluency. This enables you to quickly identify and learn the correct pronunciation.',
      english: 'We are the first and best speech recognition app designed to evaluate and give immediate detailed feedback on pronunciation and fluency. This enables you to quickly identify and learn the correct pronunciation.'
    }
  }
};

export const certifiedCourses = {
  title: {
    traditional: 'Certify Your English Skills',
    simplified: 'Certify Your English Skills',
    english: 'Certify Your English Skills'
  },
  description: {
    traditional: 'Prepare for top exams like IELTS, TOEFL, TOEIC, EIKEN, and Pearson PTE with interactive practice in pronunciation, grammar, fluency, and more. Access specialized courses and earn internationally recognized certificates to advance your career or studies.',
    simplified: 'Prepare for top exams like IELTS, TOEFL, TOEIC, EIKEN, and Pearson PTE with interactive practice in pronunciation, grammar, fluency, and more. Access specialized courses and earn internationally recognized certificates to advance your career or studies.',
    english: 'Prepare for top exams like IELTS, TOEFL, TOEIC, EIKEN, and Pearson PTE with interactive practice in pronunciation, grammar, fluency, and more. Access specialized courses and earn internationally recognized certificates to advance your career or studies.'
  },
  featuredCourse: {
    title: {
      traditional: 'IELTS Band 7',
      simplified: 'IELTS Band 7',
      english: 'IELTS Band 7'
    },
    description: {
      traditional: "Let's get serious here! IELTS Band 7 will give you the tools you need to handle complex language and understand detailed reasoning.",
      simplified: "Let's get serious here! IELTS Band 7 will give you the tools you need to handle complex language and understand detailed reasoning.",
      english: "Let's get serious here! IELTS Band 7 will give you the tools you need to handle complex language and understand detailed reasoning."
    }
  },
  courseOverview: {
    title: {
      traditional: 'Course Overview',
      simplified: 'Course Overview',
      english: 'Course Overview'
    },
    units: [
      {
        id: 'unit_1',
        number: 1,
        icon: '💻',
        title: {
          traditional: 'Work & Education (Part I)',
          simplified: 'Work & Education (Part I)',
          english: 'Work & Education (Part I)'
        },
        lessons: 6
      },
      {
        id: 'unit_2',
        number: 2,
        icon: '🏠',
        title: {
          traditional: 'Home (Part I)',
          simplified: 'Home (Part I)',
          english: 'Home (Part I)'
        },
        lessons: 6
      },
      {
        id: 'unit_3',
        number: 3,
        icon: '🎯',
        title: {
          traditional: 'Hobbies & Routines (Part I)',
          simplified: 'Hobbies & Routines (Part I)',
          english: 'Hobbies & Routines (Part I)'
        },
        lessons: 12
      },
      {
        id: 'unit_4',
        number: 4,
        icon: '🚌',
        title: {
          traditional: 'Transportation (Part I)',
          simplified: 'Transportation (Part I)',
          english: 'Transportation (Part I)'
        },
        lessons: 3
      }
    ]
  }
};

// Helper functions
export const getLearningCycleStages = () => learningCycleStages;

export const getLearningPackages = () => learningPackages;

export const getAIFeedbackData = () => aiFeedbackData;

export const getCertifiedCourses = () => certifiedCourses;

export const getStageById = (stageId) => {
  return learningCycleStages.find(stage => stage.id === stageId);
};

export const getPackageByName = (packageName) => {
  return learningPackages[packageName];
};
